@if (formModel.getPresetMark()) {
  <button class="preset-mark" (click)="click()" [class.clickable]="formModel.hasInfotext() && noClick === false" [title]="'input.presetted' | translate"><i class="icon-robot"></i></button>
}
